module.exports = {"notification.message":"Wix.com, mümkün olan iyi deneyimi size sunmak için çerezleri kullanır.","notification.got.it":"Tamam","notification.more.info":"Devamını Oku","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_tr.json
// module id = 59
// module chunks = 0